/* eslint-disable */
export default {
  toolTip: 'Tarkastele sovelluksessa {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
